import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { SHOPIFY_DOMAIN } from "@/lib/shopify";

export default function CheckoutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => {
      window.location.href = SHOPIFY_DOMAIN;
    }, 1800);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen bg-[#F4EFE6] relative">
      <Navigation />

      <section className="pt-32 pb-24 flex items-center justify-center min-h-[60vh]">
        <div className="text-center px-6 max-w-md mx-auto">
          <div className="w-16 h-16 mx-auto mb-8 border-2 border-stone-400/40 rounded-full flex items-center justify-center">
            <div className="w-3 h-3 bg-stone-700 rounded-full animate-pulse" />
          </div>

          <p className="text-[11px] tracking-[0.4em] uppercase text-stone-500 mb-5">
            UNIXORN — Secure Checkout
          </p>
          <h1 className="text-3xl md:text-4xl font-bold text-stone-900 mb-5">
            Redirecting you to checkout
          </h1>
          <p className="text-stone-600 text-base mb-10 leading-relaxed">
            All UNIXORN payments are processed securely on our flagship storefront.
            One moment.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => (window.location.href = SHOPIFY_DOMAIN)}
              className="px-8 py-5 bg-stone-900 text-[#F4EFE6] hover:bg-stone-800 transition-all duration-300 rounded-none uppercase tracking-[0.3em] font-bold text-xs"
              data-testid="checkout-shopify-now"
            >
              Continue Now
            </Button>
            <Button
              onClick={() => navigate("/")}
              variant="outline"
              className="px-8 py-5 border border-stone-700/40 text-stone-700 hover:bg-stone-900 hover:text-[#F4EFE6] hover:border-stone-900 transition-all duration-300 rounded-none uppercase tracking-[0.3em] text-xs bg-transparent"
            >
              Keep Browsing
            </Button>
          </div>

          <p className="text-xs text-stone-500 italic mt-10">
            Each UNIXORN piece exists once — then becomes legend.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
